export const siteContent = {
  hero: {
    eyebrow: 'Consultoría especializada en inocuidad alimentaria',
    title: 'Control microbiológico con criterio técnico para plantas que no pueden darse margen de error.',
    description:
      'JL Consultorías ayuda a empresas de alimentos y entornos regulados a detectar riesgos biológicos, fortalecer procesos y convertir la inocuidad en una ventaja operativa.',
    primaryCta: {
      label: 'Agendar una reunión',
      href: '#contacto'
    },
    secondaryCta: {
      label: 'Ver artículos',
      to: '/insights'
    },
    highlights: [
      'Más de 35 años de experiencia en microbiología aplicada',
      'Acompañamiento para auditorías, diagnóstico y mejora continua',
      'Trabajo orientado a riesgo real, cultura operativa y resultados sostenibles'
    ],
    metrics: [
      { value: '35+', label: 'años en procesos productivos' },
      { value: '4', label: 'líneas de servicio prioritarias' },
      { value: '5', label: 'artículos técnicos iniciales publicados' }
    ]
  },
  services: [
    {
      title: 'Auditorías microbiológicas',
      outcome: 'Detectamos puntos vulnerables antes de que se conviertan en desvío operativo o riesgo comercial.',
      details:
        'Revisión integral de procesos, higiene, control ambiental y prácticas críticas para priorizar acciones con impacto real.'
    },
    {
      title: 'Capacitación técnica',
      outcome: 'Formamos equipos que entienden por qué fallan los controles y cómo sostener una cultura preventiva.',
      details:
        'Sesiones presenciales o remotas para personal de calidad, producción y liderazgo operativo.'
    },
    {
      title: 'Asesoría a medida',
      outcome: 'Traducimos evidencia microbiológica en planes accionables alineados con tus objetivos productivos.',
      details:
        'Acompañamiento para sistemas de inocuidad, control de peligros biológicos y mejora continua.'
    },
    {
      title: 'Diagnóstico de situación',
      outcome: 'Clarificamos el estado real de la operación y definimos una hoja de ruta concreta.',
      details:
        'Análisis técnico, interpretación de hallazgos y plan de trabajo para erradicar microorganismos problema.'
    }
  ],
  painPoints: [
    'Desvíos microbiológicos repetidos sin una causa raíz clara',
    'Equipos capacitados en teoría, pero sin una cultura preventiva consistente',
    'Necesidad de preparar auditorías, certificaciones o cambios de proceso',
    'Dudas sobre limpieza, desinfección y contaminación cruzada en planta'
  ],
  methodology: [
    'Escucha operativa para entender el riesgo real de la planta y sus restricciones.',
    'Diagnóstico basado en evidencia para separar síntomas de causas raíz.',
    'Plan de acción concreto con prioridades, acompañamiento y seguimiento.'
  ],
  industries: [
    'Industria alimentaria',
    'Entornos farmacéuticos vinculados a higiene y control',
    'Equipos HACCP y áreas de calidad',
    'Operaciones con procesos sensibles a contaminación cruzada'
  ],
  about: {
    name: 'Dr. Julio César Lamela',
    role: 'Microbiólogo y asesor en inocuidad alimentaria',
    bio:
      'Especialista en microbiología alimentaria, evaluación de peligros biológicos y acompañamiento técnico a empresas que necesitan elevar su estándar de control y prevención.',
    credentials: [
      'Doctor en Medicina - Universidad de la República',
      'Especialista en Microbiología - Instituto de Higiene, Facultad de Medicina',
      'Especialista en Seguridad Alimentaria - UNIT',
      'Responsable en Gestión de Riesgos - LATU'
    ],
    contacts: [
      { label: 'Correo', value: 'jlamela005@gmail.com', href: 'mailto:jlamela005@gmail.com' },
      { label: 'WhatsApp', value: '+598 98 300 386', href: 'https://wa.me/59898300386' },
      {
        label: 'LinkedIn',
        value: 'Perfil profesional',
        href: 'https://www.linkedin.com/in/julio-c%C3%A9sar-lamela-94743647/'
      }
    ]
  },
  participations: [
    {
      title: 'Workshop de métodos rápidos y automatización',
      organization: 'Barcelona 2018, UAB',
      description:
        'Ponencia sobre microbiología alimentaria, automatización y detección en escenarios de alto control.',
      imageSrc: '/img/1609283167775.jpg'
    },
    {
      title: 'Revista Indufarma',
      organization: 'Publicación técnica',
      description:
        'Análisis sobre contaminación cruzada y gestión preventiva en industrias alimentarias.',
      imageSrc: '/generated/blog/indufarma.jpg'
    },
    {
      title: 'Hotel Estancia San Pedro del Timote',
      organization: 'Jornada técnica',
      description:
        'Conferencia sobre inocuidad y atributos microbianos vinculados a la contaminación cruzada.',
      imageSrc: 'https://i.postimg.cc/pdNyYwgW/1559347218683.jpg'
    },
    {
      title: 'Workshop MRAMA - DYCFung',
      organization: 'Participación académica',
      description:
        'Exposición sobre métodos rápidos y cuantificación en microbiología de alimentos.',
      imageSrc: '/img/176f2acf-7ea2-4e4b-b954-17c4e839760c.jpg'
    }
  ],
  faq: [
    {
      question: '¿En qué etapa conviene pedir una consultoría?',
      answer:
        'Lo ideal es intervenir antes de que un desvío se vuelva recurrente, pero también acompañamos operaciones que ya vienen lidiando con hallazgos, reclamos o exigencias de auditoría.'
    },
    {
      question: '¿La capacitación puede adaptarse al nivel del equipo?',
      answer:
        'Sí. Cada instancia se ajusta al perfil del personal, al contexto productivo y a los riesgos específicos de la operación.'
    },
    {
      question: '¿La asesoría puede ser remota?',
      answer:
        'Sí. Dependiendo del objetivo, el acompañamiento puede combinar reuniones remotas, análisis documental y visitas presenciales.'
    }
  ],
  booking: {
    title: 'Agenda una reunión inicial de 30 minutos',
    description:
      'Conversemos sobre la situación actual, las prioridades de tu operación y la mejor forma de abordar el riesgo microbiológico con una propuesta realista.',
    calendlyUrl: 'https://calendly.com/germanlamela98/30min'
  }
};
